import React, { useEffect, useContext, useState } from "react";
import { ContextProvider } from "../../../App";
import { Link, useNavigate } from "react-router-dom";
import ImageComponent from "../../utils/ImageComponent";
import { useCart } from "./CartContext";
import AddToCartComp from "./AddToCartComp";
import { RiHeartFill, RiHeartLine } from "react-icons/ri";
import { PiShoppingCartLight } from "react-icons/pi";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import useWishListData from "../../hooks/useWishListData";
import { Discountprice } from "../../utils/constant";
import SpinLoader from "../../Loader/SpinLoader";

const ProductCard = ({ product }) => {
  // console.log(product);
  const {
    id,
    image: image_Url,
    name: content,
    product_description,
    actual_price,
    offer_price,
    small_images,
    category,
    sub_category,
    priceOptions,
    inStockQuantity,
  } = product;

  const [displayQty, setDisplayQty] = useState(false);
  const [wishListVisible, setWishlistVisible] = useState(false);
  const { wishListData, setWishListData } = useWishListData();
  const [variantId, setVariantId] = useState(priceOptions[0]?._id);

  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [showControls, setShowControls] = useState(false);
  const [imageHover, setImageHover] = useState(false);

  useEffect(() => {
    // console.log("imageHover", imageHover);
    // console.log("wishListData", wishListData);
  }, [imageHover]);

  const { addToCart, newCart, handleCreateWishlist, handleRemoveWishlist } =
    useCart();
  const {
    setOpenDrawer,
    openDrawer,
    setShowLoader,
    selectedWishList,
    setSelectedWishlist,
    token,
    showGridType,
    showLandscapeType,
    showSpinLoader,
    setShowSpinLoader,
  } = useContext(ContextProvider);

  const getLowestPrice = priceOptions?.reduce((current, previuos) => {
    return current?.offer_price > previuos?.offer_price ? current : previuos;
  });

  const getHoverImageUrl = () => {
    if (imageHover && small_images?.length > 1) {
      return small_images[1];
    }
    return image_Url;
  };

  useEffect(() => {
    const isInCart = newCart?.some((item) => {
      return item?.id === product.id;
    });
    setDisplayQty(isInCart);
  }, [newCart, product?.id]);

  useEffect(() => {
    const isItemWishlisted = wishListData?.some((item) => {
      return item?.id === product?.id;
    });
    setSelectedWishlist(isItemWishlisted);
  }, [wishListData, product?.id]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setOpenDrawer(false);
  //   }, [1500]);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [openDrawer]);

  const handleWishList = (wishlistId) => {
    if (!token) {
      setShowLoader(true);
      navigate("/wishlist");
    }

    const isWishListed = wishListData.some((item) => item?.id === wishlistId);

    if (isWishListed) {
      setWishListData((prev) => prev.filter((item) => item.id !== wishlistId));

      handleRemoveWishlist(wishlistId);
    } else {
      setWishListData((prev) => [...prev, { id: wishlistId }]);

      handleCreateWishlist(wishlistId).catch(() => {
        handleCreateWishlist(wishlistId);
      });
    }
  };

  const NotifyMsg = {
    added: "Wishlist item added successfully",
    removed: "item removed successfully from Wishlist",
  };

  const removeNameSpaces = content?.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase();
  const removeSubCatSpaces = sub_category
    ?.replace(/[^a-zA-Z0-9]/g, "-")
    .toLowerCase();
  const removeCategorySpaces = category?.catKey
    ?.replace(/[^a-zA-Z0-9]/g, "-")
    .toLowerCase();

  return (
    <div
      className={`flex rounded-lg sm:p-4 p-2  ${
        showLandscapeType
          ? "flex-row md:gap-14 sm:gap-10 xs:gap-5 gap-2 shadow-md"
          : ""
      } ${
        showGridType
          ? // ? "flex-col md:gap-3 md:w-72 xs:w-64 w-48 sm:h-fit group duration-500"
            // : ""
            "flex-col md:gap-1 md:w-72 xs:w-60 w-40 sm:h-fit group duration-500"
          : ""
      } `}
    >
      {/* {selectedWishList ? (
        <WishListPopUp id={id} message={NotifyMsg?.removed} />
      ) : (
        <WishListPopUp id={id} message={NotifyMsg?.added} />
      )} */}
      <Link
        onClick={(e) => {
          e.preventDefault();
        }}
        // to={`/${removeCategorySpaces}/${removeSubCatSpaces}/${id}/${removeNameSpaces}/variant/${variantId}`}
        to={`/${removeCategorySpaces}/${removeSubCatSpaces}/${id}/${removeNameSpaces}`}
      >
        <div
          onMouseEnter={() => setWishlistVisible(true)}
          onMouseLeave={() => setWishlistVisible(false)}
          className="w-fit relative"
        >
          <div
            onMouseEnter={() => setShowControls(true)}
            onMouseLeave={() => setShowControls(false)}
            onClick={(event) => {
              event.stopPropagation();
            }}
            className={`md:w-60 sm:w-52 xs:w-48 w-36 h-36 xs:h-48 sm:h-48 md:h-60 object-cover   
               ${showLandscapeType ? "hover:bg-black " : ""}
            `}
          >
            <ImageComponent
              imageUrl={getHoverImageUrl()}
              styling={`w-full h-full object-cover duration-1000 ease-in-out rounded 
              `}
              altText={content}
              onMouseEnter={() => setImageHover(true)}
              onMouseLeave={() => setImageHover(false)}
            />
          </div>
          {/* <div
            className={`absolute flex justify-center items-center w-full bottom-[50%] text-white rounded ${
              showControls ? "opacity-100" : "opacity-0"
            }`}
          >
            <PiShoppingCartLight className="bg-main p-2" size={40} />
            <MdOutlineRemoveRedEye className="bg-secondary p-2" size={40} />
          </div> */}

          {/******   Wishlist Product Button   ******/}
          <button
            onClick={() => {
              handleWishList(id);
            }}
          >
            {wishListData.some((item) => {
              // console.log(item);
              return item?.id === id;
            }) ? (
              <div className="text-error absolute right-1 top-1 xs:right-5 xs:top-4">
                <RiHeartFill size={25} />
              </div>
            ) : (
              <div
                className={`w-6 absolute xs:top-4 top-1 xs:right-5 right-1 sm:block hidden transition-opacity duration-300 
              ${wishListVisible ? " opacity-100" : "opacity-0"} 
              `}
              >
                <RiHeartLine size={25} />
              </div>
            )}
          </button>
        </div>
      </Link>

      <div
        className={`flex flex-col items-start  ${
          showLandscapeType ? "w- gap-1" : "w-full gap-1"
        } `}
      >
        {/* <NotifySlider /> */}
        <h2
          className={`font-semibold md:text-base text-sm  ${
            showLandscapeType ? "md:text-xl" : "line-clamp-1"
          } `}
        >
          {content}
        </h2>

        {showLandscapeType && (
          <p className="text-mediumGray text-sm line-clamp-2 md:text-base min-w-full sm:line-clamp-4">
            {product_description && product_description[0]?.description}
          </p>
        )}

        {/* Old Price New Price Discount Off Section */}

        <Discountprice
          actual_price={actual_price}
          offer_price={offer_price}
          priceOptions={getLowestPrice}
          styling="md:text-lg sm:text-base text-sm font-semibold "
        />

        <p
          className={`font-bold capitalize sm:text-sm text-xs ${
            Number(inStockQuantity) >= 50 ? "text-green" : "text-error"
          } `}
        >
          {inStockQuantity >= 50 ? "in stock" : "only few left!"}
        </p>

        {showLandscapeType && (
          <Link
            // to={`/${removeCategorySpaces}/${removeSubCatSpaces}/${id}/${removeNameSpaces}/variant/${variantId}`}

            to={`/${removeCategorySpaces}/${removeSubCatSpaces}/${id}/${removeNameSpaces}`}
          >
            <button className="float-start p-1 text-xs md:p-3 md:text-base sm:p-2 sm:text-sm styleButton">
              View More
            </button>
          </Link>
        )}
      </div>

      <div className="w-full">
        {/* {showGridType &&
          (displayQty ? (
            <AddToCartComp setOpenDrawer={setOpenDrawer} menuDataId={id} />
          ) : priceOptions?.length > 1 ? (
            <Link
              to={`/${removeCategorySpaces}/${removeSubCatSpaces}/${id}/${removeNameSpaces}/variant/${variantId}`}
            >
              <button className="p-1 text-base w-full md:p-3 sm:p-2 styleButton">
                Select Option
              </button>
            </Link>
          ) : (
            <button
              onClick={() => {
                addToCart(product);
                // console.log("product", product);
                setOpenDrawer(true);
              }}
              className="p-1 text-base w-full md:p-3 sm:p-2 styleButton"
            >
              Add To Cart
            </button>
          ))} */}

        {showGridType &&
          (displayQty ? (
            <AddToCartComp
              setOpenDrawer={setOpenDrawer}
              menuDataId={id}
              displayQty={displayQty}
            />
          ) : (
            <button
              onClick={() => {
                setShowSpinLoader(true);
                addToCart(product, setOpenDrawer);
                // console.log("product", product);
              }}
              className="p-1 text-base w-full md:p-3 sm:p-2 styleButton"
            >
              Add To Cart
            </button>
          ))}
      </div>
    </div>
  );
};

export default React.memo(ProductCard);
